import { Injectable } from "@angular/core";
import { ModalService } from "@core/services/modal.service";
import { ModalLoadingComponent } from "@shared/components/modals/modal-loading/modal-loading.component";
import { NzModalRef } from "ng-zorro-antd/modal";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export default class Loadding {

    private modal!: NzModalRef | null; // Referencia al modal

    constructor(private modalService: ModalService) { }

    // Método para abrir o cerrar el modal según el estado booleano
    setModalLoadingState(isLoading: boolean): void {
        if (isLoading && !this.modal) {
        // Si el valor es true y no hay un modal ya abierto, abre el modal
        this.loadding();
        } else if (!isLoading && this.modal) {
        // Si el valor es false y hay un modal abierto, ciérralo
        this.closeModal();
        }
    }

    private loadding(): Observable<any> {
        this.modal = this.modalService.openModal(
            ModalLoadingComponent,
            'nzXs',
            {padding: '4rem' },
            {},
            false
        )   
        return this.modal.afterClose;
    }

    private closeModal(): void {
        if (this.modal) {
            this.modal.close();
            this.modal = null; // Asegúrate de limpiar la referencia
        }
    }
}

